import { createSlice } from "@reduxjs/toolkit";

export const TAB_NAME = {
  PATTERNS: 'PATTERNS',
  PROPERTIES: 'PROPERTIES',
}

const initialState = {
  activeTab: TAB_NAME.PATTERNS,
  patternList: [],
  texturesList: [],
  selectedPattern: null,
  groutColors: [],
  selectedTiles: [],
  selectedTileIndexToModify: null,
  unityUpdatedData: null,
  patternApplicationInProcess: false,
  depthValue: null,
  textureProperties: null,
  previousUnityData: null,
  undoRedoOperation: {
    isOperation: false,
    data: {},
    modifiedValue: null
  },
  previousDepthValue: null,
  textureLoading: false,
  erosionValues: null,
  heightWidthDimension: {textureWidth: '', textureHeight: ''},
  disableApplyBtn: true,
  dataForReset: null,
  enableSaveToLibraryBtn: false,
  dataForResetPrev: null,
  isSavePopupOpen: false
}

const curatorTileGroutSlicer = createSlice({
  name: "curatorTileGrout",
  initialState,
  reducers: {
    resetState: (state) => {
      let newState = {
        ...state,
        activeTab: TAB_NAME.PATTERNS,
        selectedPattern: null,
        selectedTiles: [],
        selectedTileIndexToModify: null,
        unityUpdatedData: null,
        patternApplicationInProcess: false,
        depthValue: null,
        textureProperties: null,
        previousUnityData: null,
        undoRedoOperation: {
          isOperation: false,
          data: {},
          modifiedValue: null
        },
        previousDepthValue: null,
        textureLoading: false,
        erosionValues: null,
        heightWidthDimension: null,
        disableApplyBtn: true,
        dataForReset: null,
        enableSaveToLibraryBtn: false,
        dataForResetPrev: null,
        isSavePopupOpen: false
      };
      return newState;
    },
    setActiveTab: (state, { payload }) => {
      state.activeTab = payload;
    },
    setAllPatterns: (state, { payload }) => {
      state.patternList = payload;
    },
    setAllTextures: (state, { payload }) => {
      state.texturesList = payload;
    },
    setSelectedPattern: (state, { payload }) => {
      state.selectedPattern = payload;
    },
    setGroutColors: (state, { payload }) => {
      state.groutColors = payload;
    },
    setSelectedTiles: (state, { payload }) => {
      state.selectedTiles = payload;
    },
    setSelectedTileIndxToModify: (state, { payload }) => {
      state.selectedTileIndexToModify = payload;
    },
    setUnityUpdatedData: (state, { payload }) => {
      state.unityUpdatedData = payload
    },
    setPatternApplicationInProcess: (state, { payload }) => {
      state.patternApplicationInProcess = payload;
    },
    setDepthValueRedux: (state, { payload }) => {
      state.depthValue = payload;
    },
    setTextureAPIProperties: (state, { payload }) => {
      state.textureProperties = payload;
    },
    setPreviousUnityData: (state, {payload}) => {
      state.previousUnityData = payload;
    },
    setUndoRedoOperation: (state, {payload}) => {
      state.undoRedoOperation = payload;
    },
    setPreviousDepthValue: (state, {payload}) => {
      state.previousDepthValue = payload;
    },
    setTextureLoading: (state, {payload}) => {
      state.textureLoading = payload;
    },
    setErosionValues: (state, {payload}) => {
      state.erosionValues = payload;
    },
    setHeightWidthDimension: (state, {payload}) => {
      state.heightWidthDimension = payload;
    },
    setDisableApplyBtn: (state, {payload}) => {
      state.disableApplyBtn = payload;
    },
    setDataForReset: (state, {payload}) => {
      state.dataForReset = payload;
    },
    setEnableSaveToLibrary: (state, {payload}) => {
      state.enableSaveToLibraryBtn = payload;
    },
    setDataForResetPrev: (state, {payload}) => {
      state.dataForResetPrev = payload;
    },
    setIsSavePopupOpen: (state, {payload}) => {
      state.isSavePopupOpen = payload;
    }
  },
});

export const {
  setActiveTab,
  setAllPatterns,
  setAllTextures,
  setSelectedPattern,
  setGroutColors,
  setSelectedTiles,
  setSelectedTileIndxToModify,
  setUnityUpdatedData,
  setPatternApplicationInProcess,
  setDepthValueRedux,
  resetState,
  setTextureAPIProperties,
  setPreviousUnityData,
  setUndoRedoOperation,
  setPreviousDepthValue,
  setTextureLoading,
  setErosionValues,
  setHeightWidthDimension,
  setDisableApplyBtn,
  setDataForReset,
  setEnableSaveToLibrary,
  setDataForResetPrev,
  setIsSavePopupOpen
} = curatorTileGroutSlicer.actions;
export const curatorTileGroutActions = curatorTileGroutSlicer.actions;

export const curatorTileGroutSelector = (state) => state.curatorTileGrout;
export const curatorTileGroutReducer = curatorTileGroutSlicer.reducer;
export default curatorTileGroutReducer;

export const selectActiveTab = (state) => state.curatorTileGrout.activeTab;
export const selectAllPatterns = (state) => state.curatorTileGrout.patternList;
export const selectAllColors = (state) => state.curatorTileGrout.groutColors;
export const selectTileConfiguratorTextures = (state) => state.curatorTileGrout.texturesList;
export const selectSelectedPattern = (state) => state.curatorTileGrout.selectedPattern;
export const selectSelectedTiles = (state) => state.curatorTileGrout.selectedTiles;
export const selectSelectedTileIndexToModify = (state) => state.curatorTileGrout.selectedTileIndexToModify;
export const selectUnityUpdateData = (state) => state.curatorTileGrout.unityUpdatedData;
export const selectIsPatternApplicationInProcess = (state) => state.curatorTileGrout.patternApplicationInProcess;
export const selectedDepthValue = (state) => state.curatorTileGrout.depthValue;
export const selectTextureProperties = (state) => state.curatorTileGrout.textureProperties;
export const selectPreviousUnityData = (state) => state.curatorTileGrout.previousUnityData;
export const selectUndoRedoOperation = (state) => state.curatorTileGrout.undoRedoOperation;
export const selectPreviousDepthValue = (state) => curatorTileGroutSelector(state).previousDepthValue;
export const selectTextureLoading = (state) => state.curatorTileGrout.textureLoading;
export const selectTextureForAPILoading = (state) => curatorTileGroutSelector(state).texturesList;
export const selectErosionValues = (state) => state.curatorTileGrout.erosionValues;
export const selectHeightWidthDimension = (state) => state.curatorTileGrout.heightWidthDimension;
export const selectDisableApplyBtn = (state) => state.curatorTileGrout.disableApplyBtn;
export const selectDataForReset = (state) => state.curatorTileGrout.dataForReset;
export const selectEnableSaveToLibraryBtn = (state) => state.curatorTileGrout.enableSaveToLibraryBtn;
export const selectDataForResetPrev = (state) => state.curatorTileGrout.dataForResetPrev
export const selectTileGroutSavePopupOpen = (state) => state.curatorTileGrout.isSavePopupOpen;
